import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0c30554b&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=0c30554b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules_front/5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports